import { fromJS } from 'immutable';
import Segment from '../../helpers/segment';
import { JobTypesActionTypes } from './actions';
import { createReducer } from '../../helpers/store';

const initialState = fromJS({
  errors: '',
  isLoading: true,
  jobTypes: []
});

/**
 * Called when get jobTypes request is initiated.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */

export const handleGetJobTypesRequest = (state, action) => {
  Segment.track('Getting job types');
  return state.set('isLoading', true).set('errors', '');
};

/**
 * Called when the get jobTypes request fails.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */

export const handleGetJobTypesFailure = (state, action) => {
  Segment.track('Failed to get job types', { error: action.data.error });
  return state
    .set('isLoading', false)
    .set(
      'errors',
      action.data.error || 'Sorry, we were unable to load job types.'
    );
};

/**
 * Called when get language request is successful.
 *
 * @param {Map} state
 * @param {Object} action
 * @returns {Map}
 */

export const handleGetJobTypesSuccess = (state, action) => {
  Segment.track('Got job types');
  const jobTypes = fromJS(action.response.data).map(jobType => {
    return {
      value: jobType.get('id'),
      label: jobType.get('name')
    };
  });

  return state
    .set('errors', '')
    .set('jobTypes', jobTypes)
    .set('isLoading', false);
};

export const jobTypesReducer = createReducer(initialState, {
  [JobTypesActionTypes.GET_JOB_TYPES_REQUEST]: handleGetJobTypesRequest,
  [JobTypesActionTypes.GET_JOB_TYPES_SUCCESS]: handleGetJobTypesSuccess,
  [JobTypesActionTypes.GET_JOB_TYPES_FAILURE]: handleGetJobTypesFailure
});



/** WEBPACK FOOTER **
 ** ./src/state/job_types/reducer.js
 **/